<template>
  <div>
    <HeroInfo v-if="$whitelabel.isStandalone" v-show="$route.path === '/'" />
    <div class="container">
      <!-- <GreenstormMoneyBack v-if="$whitelabel.short.toLowerCase() === 'greenstorm'" v-show="$route.path === '/'" /> -->

      <div v-if="!$whitelabel.isStandalone || ($whitelabel.isStandalone && !$whitelabel.showHeader)" v-show="$route.path === '/'" class="px-4">
        <Advantages v-bind:size="$whitelabel.homepage.advantages" v-if="$whitelabel.homepage.advantages" class="mb-4" />
      </div>
      <HomeContainer v-if="!pendingContent && home.length > 0" />
      <SearchContainer v-if="!pendingContent && home.length == 0" v-on:update:breadcrumb="currentBreadcrumb = $event" />
    </div>

    <GreenstormSeoText v-if="$whitelabel.short.toLowerCase() === 'greenstorm'" v-show="$route.path === '/'" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SearchContainer from '@/modules/search'
import HomeContainer from '@/modules/home'
import HeroInfo from '@/components/HeroInfo'
import Advantages from '@/components/Advantages'
import GreenstormSeoText from '@/components/Greenstorm/SeoText'
// import GreenstormMoneyBack from '@/components/Banner/Greenstorm/GreenstormMoneyBack'

export default {
  name: 'home',
  components: {
    SearchContainer,
    HeroInfo,
    // GreenstormMoneyBack,
    Advantages,
    HomeContainer,
    GreenstormSeoText,
  },
  computed: {
    ...mapGetters({
      locale: 'locale',
      pendingContent: 'pendingContent',
      home: 'home',
    }),
  },
  data() {
    return {
      currentBreadcrumb: '',
    }
  },
  mounted() {},
  beforeDestroy() {},
  breadcrumb() {
    return {
      label: /*this.$route.params.country || this.$route.params.name*/ this.currentBreadcrumb,
      parent: 'home',
    }
  },
}
</script>
